import {stockStatusConfig, STOCK_STATUS} from '@/constants/stock-status';

//Configuration array for controlling in-stock/out-of-stock status on B2C products
const inStockCodesB2C = [STOCK_STATUS.EnumGlobalStockStatus1, STOCK_STATUS.EnumGlobalStockStatus6];

//B2B has so many in-stock codes that it is less verbose to list out of stock codes here.
const outOfStockCodesB2B = [STOCK_STATUS.EnumGlobalStockStatus4];

/**
 * Check whether the status is in stock or not by given stock status code.
 * @param stockStatusCode
 * @return {boolean}
 */
//TODO DSO - refactor usages of this to instead use 'isInStock'
const isInStockByCode = (stockStatusCode) => {
  return inStockCodesB2C.includes(stockStatusCode);
};

const isInStockByCodeB2B = (stockStatusCode) => {
  return !outOfStockCodesB2B.includes(stockStatusCode);
};

const isInStock = (b2b, stockStatusCode) => {
  return b2b ? isInStockByCodeB2B(stockStatusCode) : isInStockByCode(stockStatusCode);
};

/**
 * Check whether the status is in warehouse or not by given stock status code.
 * @param stockStatusCode
 * @return {boolean}
 */
const isInWarehouseByCode = (stockStatusCode) => {
  return stockStatusCode === STOCK_STATUS.EnumGlobalStockStatus6;
};

/**
 * Get retailer stock message by stock status code and product type.
 * @param isBike
 * @param stockStatusCode
 * @return {string}
 */
const getRetailerStockMessage = (isBike, stockStatusCode) => {
  return stockStatusConfig[stockStatusCode]?.stockStatusMessage?.retailerLabel(isBike);
};

export {isInStockByCode, isInStock, getRetailerStockMessage, isInWarehouseByCode};
